


















import { defineComponent } from '@nuxtjs/composition-api';
import { useSlideShow } from '~/features/product/slideShow';

export default defineComponent({
  name: 'SideMenu',
  setup() {
    const { isOpen, close } = useSlideShow();
    return {
      close,
      isOpen,
    };
  },
});
